<template>
    <svg :width="size" :height="size" viewBox="0 0 48 48" :fill="color" xmlns="http://www.w3.org/2000/svg">
<path d="M38.001 9.99976L10.001 37.9998M10.001 9.99976L38.001 37.9998" :stroke="color" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>

<script>
export default {
  name: 'iconCloseLight',
  props: {
    size: Number,
    color: String
  }
}
</script>